import React from 'react';
import { Link } from 'react-router-dom';

// Langage
import "../../i18n";
import { useTranslation } from 'react-i18next';

// Icons 
import { Icon } from "@iconify/react";
import SEO from '../../Components/SEO';

function Devis() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-10">
      <SEO
        title={t('devis_title') || 'Demander un devis'}
        description={t('devis_meta') || 'Demandez un devis pour votre projet web, SEO ou marketing.'}
        canonical={'https://safaridew.vercel.app/Devis'}
      />
      <p className="text-center w-full md:max-w-xl">
        {t("devis_desc")}
      </p>

      <div className="flex justify-center items-center flex-wrap p-5 space-x-4">
        <Link
          to="https://api.whatsapp.com/send/?phone=243850605759&text&type=phone_number&app_absent=0"
          target="_blank"
          className="text-green-500 p-4 border border-transparent hover:border-gray-500 rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-300"
        >
          <Icon icon="hugeicons:whatsapp" className='text-5xl' />
        </Link>

        <Link
          to="mailto:safaridew@gmail.com"
          className="text-blue-500 p-4 border border-transparent hover:border-gray-500 rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-300"
        >

          <Icon icon="hugeicons:mail-02" className='text-5xl' />
        </Link>
      </div>
    </div>
  );
}

export default Devis;
